
class Priority {
  constructor() {
    this.init();
  }

  init() {
    this.description = 'Default';
    this.value = 10;
  }

  copy() {
    const cp = new Priority();

    cp.description = this.description;
    cp.value = this.value;

    return cp;
  }

  buildFromJSON(obj) {
    this.init();

    this.description = (obj.description) ? obj.description : undefined;
    if (obj.value) {
      const value = parseInt(obj.value);
      if (!isNaN(value)) {
        this.value = value;
      }
    }
  }

  toString() {
    return `${this.description}: ${this.value}`;
  }

  getDescription() {
    return this.description;
  }

  setDescription(description) {
    this.description = description;
  }

  getValue() {
    return this.value;
  }

  setValue(value) {
    if (value) {
      const val = parseInt(value);
      if (!isNaN(val)) {
        this.value = val;
      }
    }
  }
}

module.exports = Priority;
